(function () {
  'use strict';
  // Only the hidden hover photo is deferred. The main product photo remains native HTML.
  function ready(image) {
    if (image.complete && image.naturalWidth > 1) {
      image.removeAttribute('data-nsm-secondary');
      image.removeAttribute('data-nsm-src');
      image.removeAttribute('data-nsm-srcset');
    }
  }
  function hydrate(event) {
    var target = event.target;
    var card = target.closest && target.closest('.product-grid-item');
    if (!card) return;
    card.querySelectorAll('img[data-nsm-secondary]').forEach(function (image) {
      // Colour swapping may already have supplied a newer real image; never overwrite it.
      if (!image.getAttribute('src').startsWith('data:')) { ready(image); return; }
      image.loading = 'eager';
      image.srcset = image.getAttribute('data-nsm-srcset') || '';
      image.src = image.getAttribute('data-nsm-src');
      ready(image);
    });
  }
  document.addEventListener('pointerover', hydrate, { passive: true });
  document.addEventListener('focusin', hydrate);
  document.addEventListener('load', function (event) {
    if (event.target.matches && event.target.matches('img[data-nsm-secondary]')) ready(event.target);
  }, true);
})();
